module.exports = __webpack_public_path__ + "media/images/spi-10e031eccf332680f56ac242bbffadda.png";